import React, { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { withSentryHub } from './sentry';

export const SentryBoundary: React.FC<PropsWithChildren> = ({ children }) => {
    const ErrorBoundaryHandler = (error: Error) =>
        withSentryHub()?.captureException(error);

    return (
        <ErrorBoundary
            fallbackRender={() => <div />}
            onError={ErrorBoundaryHandler}>
            {children}
        </ErrorBoundary>
    );
};
